// extracted by mini-css-extract-plugin
export default {"container":"IFFilterSkeleton_container__Ss9ho","Circular":"IFFilterSkeleton_Circular__s7A-q","text":"IFFilterSkeleton_text__lDtPw"};